import '../scss/guest.scss';
import './appCommon.js';
import { setApplicationDefaults } from "./appCommon.js";

// Laravel Echo külön importja itt nem szükséges.
// Az Echo központilag az appCommon.js fájlban kerül betöltésre.
//
// A real-time (websocket) funkciók használatához nem az importot,
// hanem az Echo példány használatát kell megvalósítani a komponensekben.
// import "./echo.js";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Urls
import commonUrls from "./routes/common";
import guestUrls from "./routes/guest";

const Application = await setApplicationDefaults(null, _.concat(commonUrls, guestUrls));

Application
    .mount('#application');
